﻿window.addEventListener('load', function () {
    $('.owl-carousel').owlCarousel({
        autoWidth: true,
        margin: 16,
        loop: false,
        nav: true,
        dots: false,
        responsive: { 0: { nav: false }, 768: { nav: true } }
    });
});